import type { MatchVm } from "../tournamentPage/matchVm";

/** A scheduled match this long past its start has most likely never been played; it should not be the "next" match. */
const STALE_MS = 6 * 3_600_000;

type Orderable = Pick<MatchVm, "bucket" | "ms" | "start">;

/**
 * Order the arrows walk through: live matches first, then upcoming (nearest first), then finished ones (latest first).
 * Scheduled fixtures that are long overdue go to the end of the upcoming group, matches without a date after dated ones.
 */
export const orderEmbedMatches = <T extends Orderable>(all: T[], now = Date.now()): T[] => {
  const rank = (m: T) => (m.bucket === "live" ? 0 : m.bucket === "up" ? 1 : 2);
  const stale = (m: T) => m.bucket === "up" && !!m.start && m.ms < now - STALE_MS;
  return [...all].sort((x, y) => {
    if (rank(x) !== rank(y)) return rank(x) - rank(y);
    if (!x.start !== !y.start) return x.start ? -1 : 1;
    if (stale(x) !== stale(y)) return stale(x) ? 1 : -1;
    return x.bucket === "past" ? y.ms - x.ms : x.ms - y.ms;
  });
};
